/**
 * Sichtbarer Hinweis statt stiller Leere ohne Anmeldung (20.09.2026).
 *
 * Seit `ProtectedRoute` nicht mehr zu /login umleitet, läuft eine fehlende
 * Session sonst still ins Leere: RLS lässt `anon` auf keiner v5_/v6_-Tabelle
 * etwas sehen, jede Seite zeigt dann kommentarlos „keine Daten". Dieser
 * Balken macht sichtbar, WARUM — ohne den alten Zwangs-Redirect wieder
 * einzuführen.
 *
 * GEMEINSAM FÜR APP UND DEMO-MODUS: Bis 20.09.2026 stand hier nur eine
 * Kopie in App.tsx, und DemoApp.tsx behauptete in einem Kommentar, die
 * Watchlist-RLS erlaube anonymen Lesezugriff. Das war seit der
 * RLS-Reparatur vom 10.08. nicht mehr wahr — die Demo zeigte seitdem
 * ebenso still eine leere Watchlist. Eine gemeinsame Komponente verhindert,
 * dass beide Stellen wieder auseinanderlaufen.
 */
import { Link } from 'react-router-dom';

export function NichtAngemeldetBanner() {
  return (
    <div className="flex items-center justify-center gap-2 border-b border-amber-900/40 bg-amber-950/40 px-3 py-2 text-xs text-amber-200">
      <span>Nicht angemeldet — deine Daten werden nicht angezeigt.</span>
      <Link
        to="/login"
        className="font-medium underline underline-offset-2 hover:text-amber-100 focus-ring"
      >
        Jetzt anmelden
      </Link>
    </div>
  );
}
